import { useSecuritiesSecurityFieldApi } from '../api';

export const useSecuritiesSecurityCCurrencyCode = () => {
  const response = useSecuritiesSecurityFieldApi('C_CURRENCY.CODE');
  return response;
};
